import React from "react";
import { observer, inject } from "mobx-react";
import { $util, $const } from "../../helper";
// import classnames from 'classnames';

import "./stylesheets/UserMenu.scss";
import Language from "../language/language";

@inject("authStore", "languageStore", "commonStore")
@observer
export default class UserMenu extends React.Component {
  goToPersonCenter = () => {
    this.customEvent("personalCenter");
    window.location.href = $util.getPersonCenterUrl(
      this.props.languageStore.lang
    );
  };
  goToResetPassword = () => {
    this.customEvent("resetPassword");
    window.location.href = $util.getResetPasswordUrl();
  };

  login = () => {
    this.customEvent("login");
    window.location.href = $util.getLoginUrl(this.props.languageStore.lang);
  };

  logout = () => {
    this.customEvent("logout");
    this.props.authStore.logout(this.props.languageStore.lang);
  };

  register = () => {
    this.customEvent("register");
    window.location.href = $util.getRegisterUrl(this.props.languageStore.lang);
  };

  /**
   * 自定义埋点
   */
  customEvent = (buttonName) => {
    this.props.commonStore.gTag("event", "topFunction", {
      pageName: $util.getPageName(),
      buttonName: buttonName,
    });
  };

  render() {
    const user = this.props.authStore.user;
    return (
      <div className="nav-user">
        <img
          className="user-avatar"
          alt={user.nickname}
          src={
            $util.getSafePicUrl(user.avatar)
              ? $util.getSafePicUrl(user.avatar)
              : $const.DEFAULT_AVATAR
          }
        />
        <div className="user-dropdown">
          {user ? (
            <ul>
              <li className="nav-user-item welcome-user-item">
                <Language resource="WELCOME" />
                {` ${user.nickname}`}
              </li>
              <li onClick={this.goToPersonCenter} className="nav-user-item">
                <Language resource="PERSON_CENTER" />
              </li>
              <li onClick={this.goToResetPassword} className="nav-user-item">
                <Language resource="CHANGE_PASSWORD" />
              </li>
              <li onClick={this.logout} className="nav-user-item">
                <Language resource="LOGOUT" />
              </li>
            </ul>
          ) : (
            <ul>
              <li onClick={this.login} className="nav-user-item">
                <Language resource="LOGIN" />
              </li>
              <li onClick={this.register} className="nav-user-item">
                <Language resource="REGISTER" />
              </li>
            </ul>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/userMenu.js